/**
 * Minutes after which a build still marked active was abandoned (the backend's STALE_AFTER_MINUTES). A build that
 * carries its GPU box's deadline (`deadline_at`) is abandoned DEADLINE_GRACE_MINUTES after it instead.
 */
const STALE_AFTER_MINUTES = { requested: 30, checking: 90, building: 520 };
const DEADLINE_GRACE_MINUTES = 30;

/** Whether the backend is building this project's 3D view right now (not an abandoned build). */
export const isView3dBuilding = (view3d, now = Date.now()) => {
	const limit = STALE_AFTER_MINUTES[view3d?.status];
	if (!limit) return false;
	const deadline = Date.parse(view3d.deadline_at);
	if (!Number.isNaN(deadline)) return now - deadline < DEADLINE_GRACE_MINUTES * 60 * 1000;
	const updated = Date.parse(view3d.updated_at);
	return Number.isNaN(updated) || now - updated < limit * 60 * 1000;
};

/** Whether an active build is still waiting for a free GPU (every type was sold out; the backend tries again). */
export const isWaitingForGpu = view3d =>
	view3d?.status === 'checking' && view3d?.reason_code === 'waiting_for_gpu';
